const styles = {

  hasDiscountContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    // `alignItems` sólo tiene efecto cuando se pasa un `adornment` junto al
    // texto; con un único hijo el resultado no cambia. Sin `gap`: el propio
    // adorno gestiona qué tan pegado va.
    alignItems: 'center',
  },

  hasDiscountText: {
    padding: 0.5,
    '&.MuiTypography-root': {
      color: '#fff',
      '&.MuiTypography-quote': {
        fontSize: '10px',
      },
    },
    '&.blackColor': {
      color: '#000',
    },
  },
}

export default styles
